import { SET_SCROLL } from "./constants";

export const initialState = { scroll: 0 };

export default (state, action) => {
  switch (action.type) {
    case SET_SCROLL:
      return { ...state, scroll: action.scroll };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/reducer.js